import {Route} from 'react-router-dom';
import React from 'react';

const Login = React.lazy(() => import('./views/Login'));
const Logout = React.lazy(() => import('./views/Logout'));
const Register = React.lazy(() => import('./views/Register'));
const ForgetPassword = React.lazy(() => import('./views/ForgetPassword'));
const Confirm = React.lazy(() => import('./views/Confirm'));

const authRoutes = {
    path: '/account',
    name: 'Auth',
    children: [
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            route: Route,
            show: false,
        },
        {
            path: '/account/logout',
            name: 'Logout',
            component: Logout,
            route: Route,
            show: false,
        },
        {
            path: '/account/register',
            name: 'Register',
            component: Register,
            route: Route,
            show: false,
        },
        {
            path: '/account/confirm',
            name: 'Confirm',
            component: Confirm,
            route: Route,
            show: false,
        },
        {
            path: '/account/forget-password',
            name: 'Forget Password',
            component: ForgetPassword,
            route: Route,
            show: false,
        },
    ],
};

export default authRoutes;
